import { BasePublicApi } from '#packages/apilib';
import { ResizeGapsScope } from './resizeGapsScope';
import { findGapUnderCursor } from './findGapUnderCursor';

function tryShowGapBoxUnderCursor(scope: ResizeGapsScope) {
  const { editorAPI, resizeGapsStore } = scope;

  const gap = findGapUnderCursor(editorAPI);
  if (gap) {
    resizeGapsStore.setGap(gap);
  } else {
    resizeGapsStore.clearGap();
  }
}

function hideGapBox(scope: ResizeGapsScope) {
  scope.resizeGapsStore.clearGap();
}

export class ResizeGapsApi extends BasePublicApi<ResizeGapsScope> {
  tryShowGapBoxUnderCursor = this.bindScope(tryShowGapBoxUnderCursor);
  hideGapBox = this.bindScope(hideGapBox);
}
